import isEmpty from 'lodash/isEmpty';

import type { TaskData } from 'chaika-frontend-types/frontend-cms';

import { SimpleList } from '@store/models/SimpleList';

export interface TaskListFilterParams {
    ids?: string[];
    end?: Date;
    parentEntryId?: string;
}

export class TaskList extends SimpleList<TaskData, TaskListFilterParams> {
    protected filterValue(task: TaskData, { end, ids, parentEntryId }: TaskListFilterParams): boolean {
        return (
            (!isEmpty(task.end) ? this.filterFilterValueBeforeFieldValue(task, end, 'end') : true) &&
            this.filterFieldValueByArray(task, ids, 'id') &&
            this.filterFieldValue(task, parentEntryId, 'parentEntryId')
        );
    }
}
